<template>
  <div class="el-card">
    <div class="el-card__header" v-if="$slots.header || header">
      <slot name="header">{{ header }}</slot>
    </div>
    <div class="el-card__body" :style="bodyStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ElCard',

    props: ['header', 'bodyStyle']
  };
</script>



// WEBPACK FOOTER //
// node_modules/element-ui/packages/card/src/main.vue